import React, { useContext, useEffect, useState } from 'react';
import '@gouvfr/dsfr/dist/component/accordion/accordion.min.css';
import { AccordeonDefaultProps } from "./AccordeonMi.types";
import { AccordeonMiContext } from "./AccordeonMi.context";
var AccordeonMi = function (_a) {
    var Component = _a.as, id = _a.id, titre = _a.titre, ComponentTitreBalise = _a.titreAs, children = _a.children, onOpen = _a.onOpen, onClose = _a.onClose;
    if (!Component) {
        Component = "div";
    }
    if (!ComponentTitreBalise) {
        ComponentTitreBalise = "h2";
    }
    var accordeonContext = useContext(AccordeonMiContext);
    var activeAccordeonAuto = undefined;
    var handleAccordeon = function () { };
    if (accordeonContext) {
        activeAccordeonAuto = accordeonContext.activeAccordeonId;
        handleAccordeon = accordeonContext.handleAccordeon;
    }
    else {
        // Si l'accordéon n'est pas dans un groupe d'accordéon il n'a pas de contexte
        // on utilise alors un useState
        var _b = useState(), activeAccordeon = _b[0], setActiveAccordeon_1 = _b[1];
        activeAccordeonAuto = activeAccordeon;
        handleAccordeon = function (id) {
            if (activeAccordeonAuto === id) {
                setActiveAccordeon_1(undefined);
            }
            else {
                setActiveAccordeon_1(id);
            }
        };
    }
    useEffect(function () {
        if (id === activeAccordeonAuto) {
            if (onOpen) {
                onOpen();
            }
        }
        else {
            if (onClose) {
                onClose();
            }
        }
    }, [activeAccordeonAuto]);
    var idAccordeon = 'accordeon-' + id;
    var isOpen = id === activeAccordeonAuto;
    var classCollapse = 'fr-collapse';
    if (isOpen) {
        classCollapse += ' fr-collapse--expanded';
    }
    var onClick = function () {
        handleAccordeon(id);
    };
    var styleDiv = {};
    if (isOpen) {
        styleDiv = { maxHeight: "none", collapse: "0" };
    }
    return (React.createElement(Component, { className: "fr-accordion dsmi-accordion" },
        React.createElement(ComponentTitreBalise, { className: "fr-accordion__title" },
            React.createElement("button", { type: "button", className: "fr-accordion__btn", "aria-expanded": isOpen, "aria-controls": idAccordeon, onClick: onClick }, titre)),
        React.createElement("div", { className: classCollapse, id: idAccordeon, style: styleDiv }, isOpen ? children : null)));
};
AccordeonMi.defaultProps = AccordeonDefaultProps;
export default AccordeonMi;
